import { SvgIcon, SvgIconProps } from '@mui/material';

const DarkModeIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_16012_12625)">
      <mask
        id="mask0_16012_12625"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_16012_12625)">
        <path
          d="M12.0287 20.5C9.66774 20.5 7.66083 19.6736 6.00799 18.0208C4.35533 16.3681 3.52899 14.3612 3.52899 12C3.52899 9.73717 4.29658 7.7965 5.83174 6.178C7.36691 4.55934 9.24666 3.68267 11.471 3.548C11.6147 3.548 11.7557 3.55317 11.8942 3.5635C12.0326 3.57384 12.1684 3.58925 12.3017 3.60975C11.7916 4.08659 11.3852 4.66284 11.0827 5.3385C10.7801 6.01417 10.6287 6.73467 10.6287 7.50001C10.6287 9.13884 11.2024 10.5319 12.3497 11.6793C13.4969 12.8264 14.8899 13.4 16.5287 13.4C17.3044 13.4 18.0275 13.2488 18.698 12.9463C19.3685 12.6436 19.939 12.2372 20.4095 11.727C20.43 11.8603 20.4454 11.9963 20.4557 12.1348C20.4659 12.2731 20.471 12.4141 20.471 12.5578C20.3428 14.7821 19.4695 16.6618 17.851 18.197C16.2323 19.7323 14.2916 20.5 12.0287 20.5ZM12.0287 19C13.4954 19 14.8121 18.5958 15.9787 17.7875C17.1454 16.9792 17.9954 15.925 18.5287 14.625C18.1954 14.7083 17.8621 14.775 17.5287 14.825C17.1954 14.875 16.8621 14.9 16.5287 14.9C14.4787 14.9 12.7329 14.1792 11.2912 12.7375C9.84958 11.2958 9.12874 9.55 9.12874 7.50001C9.12874 7.16667 9.15374 6.83334 9.20374 6.5C9.25374 6.16667 9.32041 5.83334 9.40374 5.5C8.10374 6.03334 7.04957 6.88334 6.24124 8.05C5.43291 9.21667 5.02874 10.5333 5.02874 12C5.02874 13.9333 5.71207 15.5833 7.07874 16.95C8.44541 18.3167 10.0954 19 12.0287 19Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_16012_12625">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
export default DarkModeIcon;
